import { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Menu } from "lucide-react";
import { Sidebar } from "./Sidebar";
import { HappyHourBanner } from "./HappyHourBanner";
import { ShiftStartPrompt } from "./ShiftStartPrompt";
import { Button } from "@/components/ui";
import { useUIStore } from "@/stores";

export function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const posExpanded = useUIStore((s) => s.posExpanded);

  const hideSidebar = posExpanded && location.pathname === "/pos";

  return (
    <div className="min-h-screen bg-background">
      {!hideSidebar && (
        <header className="fixed left-0 right-0 top-0 z-30 flex h-14 items-center gap-2 border-b bg-background px-4 md:hidden">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setSidebarOpen(true)}
          >
            <Menu className="h-6 w-6" />
          </Button>
          <div className="min-w-0 flex-1">
            <HappyHourBanner variant="inline" />
          </div>
        </header>
      )}

      {!hideSidebar && (
        <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      )}

      <main
        className={
          hideSidebar ? "min-h-screen" : "min-h-screen pt-14 md:pl-64 md:pt-0"
        }
      >
        <Outlet />
      </main>
      <ShiftStartPrompt />
    </div>
  );
}
